import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "@/constants";
import { HttpService } from "@/services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.FMIS_SERVER_PREFIX}/report`;
const endpoints = {
    // FMIS Report Endpoint Start
    getExpenditureReport: () => `${RESOURCE_ENDPOINT}/expenditure`,
    getExpenditureSummaryReport: () => `${RESOURCE_ENDPOINT}/expenditure-summary`,
    getRevenueSummaryReport: () => `${RESOURCE_ENDPOINT}/revenue-summary`,
    getExpenseIncomeSummaryReport: () => `${RESOURCE_ENDPOINT}/expense-income-summary`,
    getIncomeReport: () => `${RESOURCE_ENDPOINT}/income`,
    // FMIS Report Endpoint End
};

export default class FmisReportApi {
    // FMIS Report Endpoint Start
    public getExpenditureReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getExpenditureReport();
        return HttpService.get(url, params, headers);
    };
    public getExpenditureSummaryReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getExpenditureSummaryReport();
        return HttpService.get(url, params, headers);
    };
    public getIncomeReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getIncomeReport();
        return HttpService.get(url, params, headers);
    };
    public getRevenueSummaryReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getRevenueSummaryReport();
        return HttpService.get(url, params, headers);
    };
    public getExpenseIncomeSummaryReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getExpenseIncomeSummaryReport();
        return HttpService.get(url, params, headers);
    };
    // FMIS Report Endpoint End
}
